module.exports = __webpack_public_path__ + "img/bgc6.46a3f2c5.png";